import { configureStore } from '@reduxjs/toolkit'
import spinnerstate from './Core/guards/storeStates/spinnerstate';
import formstate from './Core/states/formstate';

export const store = configureStore({
    reducer: {
        spinnerState: spinnerstate,
        formState: formstate
    }
})